module.exports = __webpack_public_path__ + "epdf-app/home/home-3JnUXtFy.html";